import React from 'react';
import styled from 'styled-components';
import { FaDiscord } from 'react-icons/fa';
import { theme } from '../../theme';
import { social } from '../../config/social';

const Btn = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.4rem;
  background: #5865f2;
  border-radius: ${theme.radii.full};
  font-size: 0.85rem;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
  transition: ${theme.transitions.default};

  &:hover { filter: brightness(1.1); transform: translateY(-2px); }
`;

// Bouton "Rejoindre le Discord" (masqué si aucun Discord configuré).
export default function DiscordButton({ label = 'Rejoindre le Discord' }) {
  if (!social.discord) return null;
  return (
    <Btn href={social.discord} target="_blank" rel="noreferrer">
      <FaDiscord /> {label}
    </Btn>
  );
}
